import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { PAGINAS, ROUTES, FUNCIONALIDADES } from '../../../routes';
import { getfloatToTimeString } from '../../../utils';
import { getJornadasTrabalho } from './jornadas_trabalho.service';
import GridBase from '../../../components/grid_base';
export var JornadasTrabalhoListar = function () {
    var COLUNAS_FUNCIONALIDADE = [
        { field: 'nome', headerName: 'Nome', width: 350 },
        {
            field: 'total_horas',
            headerName: 'Total de Horas',
            width: 200,
            valueGetter: function (value) { return (value ? getfloatToTimeString(value) : 0); },
        },
        { field: 'situacao', headerName: 'Situação', width: 150 },
    ];
    return (_jsx(GridBase, { pagina: PAGINAS.JORNADAS_TRABALHO, paginaPermissao: FUNCIONALIDADES.JORNADAS_TRABALHO, rota: ROUTES.JORNADAS_TRABALHO, columns: COLUNAS_FUNCIONALIDADE, fetchData: function (str, _, pag) { return getJornadasTrabalho(str, pag); } }));
};
export default JornadasTrabalhoListar;
